<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="fillColor"
    d="M9.326 12.844a1 1 0 0 1 0-1.688l8.137-5.178A1 1 0 0 1 19 6.822v10.356a1 1 0 0 1-1.537.844l-8.137-5.178Z"
  />
  <rect width="2" height="14" [attr.fill]="fillColor" rx="1" transform="matrix(-1 0 0 1 7 5)" />
</svg>
